import * as am4core from "@amcharts/amcharts4/core";
import * as am4maps from "@amcharts/amcharts4/maps"
import am4geodata_worldHigh from "@amcharts/amcharts4-geodata/worldHigh";
import { AddOnSearchReloadOperation } from '../search';


// Map Colors
const DarkGrey = "#B2B3B7";                 // all possible country available in filters
const LightGrey = "#C7C8CA";                // All Country not in filters
const Blue = "#1E32FA";     // Selected Country

//Complete list of countries
const searchMapQuery = '[data-amchart-map-countries]';
const mapItemsKey = 'amchart-map-countries';

// List of countries available to filter on
const countriesDDLNameQuery = '[data-countries-ddl-name]';
const countriesDDLNameKey = 'countries-ddl-name';

var allIataCountries: MapItem[];
var chart: am4maps.MapChart;

var DDLCountriesName;
var countryAll;
var NdcMatchmakerMapScope;

class CountryGroup {
    name: string;
    color: string;
    data: CountryItem[];
}

class CountryItem {
    encodedTitle: string;
    title: string;
    id: string;
}

interface MapItem {
    id: string;
    title: string;
    color: string;
}

function parseObject(value: any) {
	try {
		return JSON.parse(decodeHtml(value));
	} catch(e){
		return false;
	}
}

function decodeHtml(value: any): string {
    var textArea = document.createElement('textarea');
    textArea.innerHTML = value;
    return textArea.value;
}

AddOnSearchReloadOperation(loadMap);

am4core.ready(function () {
	try {
		//Get Scope
		NdcMatchmakerMapScope = $('#ndcMatchmakerMap');

		if (NdcMatchmakerMapScope.length == 0) {
			return;
		}

		// Load all IATA countries to include in maps.
		$(document).find(searchMapQuery).each((index, mapElement) => {
			const mapJQuery = $(mapElement);
			const mapItems: MapItem[] = parseObject(mapJQuery.data(mapItemsKey));

			//keep all countries
			allIataCountries = mapItems;
		});

		//Get Countries DDL Name
		$(document).find(countriesDDLNameQuery).each((index, mapElement) => {
			const mapJQuery = $(mapElement);
			DDLCountriesName = mapJQuery.data(countriesDDLNameKey);
		});

	  //  CountriesDDL = getAvalaibleCountries(NdcMatchmakerMapScope);

		//Load all country
		countryAll = getAllCountries(NdcMatchmakerMapScope);

		chart = am4core.create("searchMapdiv", am4maps.MapChart);

		chart.geodata = am4geodata_worldHigh;

		// Set projection
		chart.projection = new am4maps.projections.Miller();

		// home button
		var buttonHome = chart.chartContainer.createChild(am4core.Button);
		buttonHome.icon = new am4core.Sprite();
		buttonHome.icon.path = "M16,8 L14,8 L14,16 L10,16 L10,10 L6,10 L6,16 L2,16 L2,8 L0,8 L8,0 L16,8 Z M16,8";
		buttonHome.padding(6, 5, 6, 5);
		buttonHome.width = 45;
		buttonHome.align = "left";
		buttonHome.marginRight = 15;
		buttonHome.events.on("hit", function () {
			chart.goHome();
		});

		loadMap(NdcMatchmakerMapScope);
	} catch(e){
		console.warn('SearchMap initialization was not successful');
		return false;
	}
});


function loadMap(scope: JQuery<HTMLElement>) {

    //Get Scope
    NdcMatchmakerMapScope = $('#ndcMatchmakerMap');

    if (NdcMatchmakerMapScope.length == 0) {
        return;
    }

    var excludedCountries = ["AQ"];

    // Get all countries(in darkgrey)
    var countryAvailableInFilters = getAvalaibleCountries(NdcMatchmakerMapScope);
    //Get available filters
    var countrySelectedInFilters = getSelectedCountries(NdcMatchmakerMapScope);
    // This array will be populated with country IDs to exclude from the world series

    var groups = [];
    if (countryAll.data.length > 0) {
        groups.push(countryAll);
    }
    if (countryAvailableInFilters.data.length > 0) {
        groups.push(countryAvailableInFilters);
    }
    if (countrySelectedInFilters.data.length > 0) {
        groups.push(countrySelectedInFilters);
    }

    chart.series.clear();
    // Create a series for each group, and populate the above array
    groups.forEach((group) => {

        scope = $('#ndcMatchmakerMap');

        var series = chart.series.push(new am4maps.MapPolygonSeries());

        series.name = group.name;
        series.useGeodata = true;

        var includedCountries = [];

        group.data.forEach(function (country) {
            includedCountries.push(country.id);
            excludedCountries.push(country.id);
        });

        series.include = includedCountries;
        series.fill = am4core.color(group.color);
        series.setStateOnChildren = true;
     //   series.calculateVisualCenter = true;

        var mapPolygonTemplate = series.mapPolygons.template;
        mapPolygonTemplate.fill = am4core.color(group.color);
        mapPolygonTemplate.fillOpacity = 0.8;
        mapPolygonTemplate.nonScalingStroke = true;

        // States
        var hoverState = mapPolygonTemplate.states.create("hover");
        hoverState.properties.fill = am4core.color(Blue);

        // Create disable state
        var activeState = mapPolygonTemplate.states.create("disabled");
        activeState.properties.disabled = true;

        // Create active state
        var activeState = mapPolygonTemplate.states.create("active");
        activeState.properties.fill = am4core.color(Blue);

        mapPolygonTemplate.tooltipText = "{title}";

        series.data = JSON.parse(JSON.stringify(group.data));

        // activate or de-activate countries on hit event
        mapPolygonTemplate.events.on("hit", function (ev) {

            ev.target.isActive = !ev.target.isActive;
            var data = ev.target.dataItem.dataContext;

            var isSelectableFilter = getAvalaibleCountries(scope).data.find(x => x.title == data.title);

            if (!isSelectableFilter) {
                ev.target.isActive = !ev.target.isActive;
                return;
            }

            // get already applied filters
            var filtersToApply = [] = getSelectedCountries(scope).data.map(x => x.encodedTitle);

            // get new filter
            var newFilter = getAvalaibleCountries(scope).data.find(x => x.title == data.title);

            if (filtersToApply.includes(newFilter.encodedTitle)) {
                filtersToApply = filtersToApply.filter(function (value, index, arr) {
                    return value != newFilter.encodedTitle;
                });
            }
            else {
                filtersToApply.push(newFilter.encodedTitle);
            }

            $("[name=" + DDLCountriesName + "]").val(filtersToApply);
            scope.find('form#searchForm').submit();
        })

    });
   }


function getAllCountries(scope: JQuery<HTMLElement>) {
    var filters = new CountryGroup();
    filters.color = LightGrey;
    filters.name = "AllCountry"
    filters.data = [];

    Array.from(allIataCountries).forEach((iatacountry, index) => {
        var filter = new CountryItem();
        filter.id = iatacountry.id;
        filter.title = iatacountry.title;
        filters.data.push(filter);
    });
    return filters;
}


function getAvalaibleCountries(scope: JQuery<HTMLElement>)
{
    var filters = new CountryGroup();
    filters.color = DarkGrey;
    filters.name = "AvalaibleCountry"
    filters.data = [];

    var selectedCountry = scope.find("[name='" + DDLCountriesName + "'] option");
    Array.from(selectedCountry).forEach((iatacountry, index) => {
        var country = allIataCountries.find(x => x.title == iatacountry.text.substring(0, iatacountry.text.length - 4).trim());

        if (country) {
            var filter = new CountryItem();
            filter.encodedTitle = iatacountry.value;
            filter.id = country.id;
            filter.title = country.title;
            filters.data.push(filter);
        }
    });
    return filters;
}


function getSelectedCountries(scope: JQuery<HTMLElement>) {

    var filters = new CountryGroup();
    filters.name = "SelectedCountry";
    filters.color = Blue;
    filters.data = [];

    var activeFilters = scope.find("[name='" + DDLCountriesName + "'] option:selected");
    if (activeFilters.length > 0) {
        Array.from(activeFilters).forEach((option, index) => {
            if (option.selected) {
                var country = allIataCountries.find(x => x.title == option.text.substring(0, option.text.length - 4));
                if (country) {
                    var filter = new CountryItem();
                    filter.encodedTitle = option.value;
                    filter.id = country.id;
                    filter.title = country.title;
                    filters.data.push(filter);
                }
            }
        });
    }

    return filters;

}
